export default function BlogHero() {
  return (
    <section className="relative pt-40 pb-24 md:pb-32 overflow-hidden bg-[#f0f9f9]">
      {/* Decorative background shapes */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#e6f6f5] rounded-full blur-3xl opacity-60 -translate-y-1/2 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-[#eaf7f9] rounded-full blur-3xl opacity-50 translate-y-1/3 -translate-x-1/4"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl">
          {/* Pill Label */}
          <div className="inline-flex items-center gap-2 border border-[#418b86]/30 text-[#418b86] text-xs font-medium px-4 py-1.5 rounded-full mb-6">
            <span className="w-1.5 h-1.5 rounded-full bg-[#4db8b1] inline-block"></span>
            Insights & Inspiration
          </div>

          {/* Headline */}
          <h1
            className="text-4xl md:text-6xl font-light text-[#2d2d2d] leading-tight mb-6"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Thoughts on
            <br />
            <span className="font-semibold italic">Healing & Growth.</span>
          </h1>

          {/* Subtext */}
          <p className="text-[#6b6b6b] text-base md:text-lg font-light mb-10 max-w-lg leading-relaxed">
            A gentle collection of reflections, practical tools, and honest conversations about mental health, relationships, and the journey toward feeling more like yourself.
          </p>
        </div>
      </div>

      {/* Decorative image strip */}
      <div className="mt-10 overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid grid-cols-3 gap-4 h-48 md:h-64 rounded-2xl overflow-hidden">
            <div className="overflow-hidden rounded-xl">
              <img
                src="/images/blog-hero1.jpg"
                alt="Peaceful nature"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="overflow-hidden rounded-xl">
              <img
                src="/images/blog-hero2.jpg"
                alt="Calm lake"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="overflow-hidden rounded-xl">
              <img
                src="/images/blog-hero3.jpg"
                alt="Cozy space"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}